import { Box, HStack, Link, Text } from '@chakra-ui/react'

const Footer = ({ onRouteChange }) => {
  return (
    <Box
      as="footer"
      width="100%"
      py={4}
      bg="gray.50"
      mt="auto"
    >
      <HStack
        justify="center"
        spacing={{ base: 2, md: 6 }}
        fontSize="xs"
        flexWrap="wrap"
      >
        <Text color="gray.500" display={{ base: 'none', md: 'block' }}>© 2026 Demos. Alle rechten voorbehouden.</Text>
        <Text color="gray.500" display={{ base: 'block', md: 'none' }}>© 2026 Demos</Text>
        <Text color="gray.400">•</Text>
        <Link
          color="gray.500"
          onClick={() => onRouteChange('privacyPolicy')}
          _hover={{ color: 'gray.700', textDecoration: 'underline' }}
          cursor="pointer"
        >
          Privacybeleid
        </Link>
        <Text color="gray.400">•</Text>
        <Link
          color="gray.500"
          onClick={() => onRouteChange('termsOfService')}
          _hover={{ color: 'gray.700', textDecoration: 'underline' }}
          cursor="pointer"
        >
          Algemene Voorwaarden
        </Link>
      </HStack>
    </Box>
  )
}

export default Footer
